import { useState } from 'react';
// components
import {
  IEditForm,
  CasEditForm,
  CasRHFSwitch,
  CasRHFTextField,
  CasRHFPercentField,
  CasRHFCurrencyField,
  CasStackRow,
} from 'src/compass/shared/components';
import {
  CasAsOfContainer,
  EntityInfoCMESchedules,
  useDefaultAsOfValues,
} from 'src/compass/application/commissions';
import { CasRHFRiskManagerSelect } from 'src/compass/application/general/components/CasRiskManagerSelect';

// schema
import { CMEScheduleSchema } from './CMEScheduleSchema';
import CommissionAdjustment from './CommissionAdjustment';

// ----------------------------------------------------------------------

export default function CMESchedulesForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};
  const editMode = !!id;

  const [asofReadonly, setAsofReadonly] = useState(false);

  const [selectedEmployee, setSelectedEmployee] = useState();

  const defaultValues = useDefaultAsOfValues(row, { isActive: true });

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity={EntityInfoCMESchedules.entity}
      schema={CMEScheduleSchema}
    >
      <CasStackRow>
        <CasRHFRiskManagerSelect
          name="servicingBrokerId"
          label="Relationship Owner"
          onChange={(_, value) => setSelectedEmployee(value)}
          disabled={editMode}
        />

        <CasRHFSwitch
          name="isActive"
          label="Active"
          helperText="(When inactive, can remain on existing accounts, but can no longer be assigned to accounts.)"
        />
      </CasStackRow>
      <CasRHFTextField name="description" label="Description" />
      <CasAsOfContainer
        entityTitle='CME Schedule AsOf'
        entityId={id}
        deleteChildEntity="Cme/CommSchedule/AsOf"
        initialAsOfList={row?.asOfs}
        initialAsOf={defaultValues.asOf}
        readOnly={asofReadonly}
        setReadOnly={setAsofReadonly}
      >
        <CasRHFCurrencyField
          name="asOf.clearingRateAmount"
          label="Clearing (per trade)"
          disabled={asofReadonly}
          fullWidth={false}
        />
        <CasRHFPercentField name="asOf.totalRatePercent" label="Broker Rate" disabled={asofReadonly} />
        <CommissionAdjustment selectedEmployee={selectedEmployee} asofReadonly={asofReadonly} />
      </CasAsOfContainer>
    </CasEditForm>
  );
}
